import React from "react";
import DepartmentHome from "../components/DepartmentHome.jsx";

const items = [
  ["Quality Center", "/admin/quality", "Incidents, complaints and quality follow-up"],
  ["Progress Notes", "/admin/progress-notes", "Review caregiver visit notes"],
  ["Visit Verification", "/admin/visit-verification", "Confirm visits happened as scheduled"],
  ["Agency Intelligence", "/admin/intelligence", "Agency-wide risk and performance insights"],
  ["Dementia Training", "/admin/dhhs/dementia-training", "Track required dementia training per caregiver (DHHS)"],
  ["TB Testing", "/admin/dhhs/tb-testing", "Track caregiver TB test dates and results (DHHS)"],
  ["QA Meetings", "/admin/dhhs/qa-meetings", "Record quality assurance meetings and minutes (DHHS)"],
  ["PCA Supervision", "/admin/dhhs/pca-supervision", "Log required PCA supervisory visits (DHHS)"],
];

const icons = {
  "Quality Center": "🛡️",
  "Progress Notes": "📝",
  "Visit Verification": "✅",
  "Agency Intelligence": "🧠",
  "Dementia Training": "🧓",
  "TB Testing": "🩺",
  "QA Meetings": "📋",
  "PCA Supervision": "🤝",
};

export default function QualityHome() {
  return (
    <DepartmentHome
      title="Quality & Compliance"
      description="Incidents, progress notes, visit verification, and agency-wide intelligence."
      items={items}
      icons={icons}
    />
  );
}
